import Vue from 'vue';
import Vuex from 'vuex';
// import page from '../page/module'
Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        // url: 'http://119.27.160.213:8087/web',
        // url: 'https://www.lxgj.com/ipms',
        loginUrl: 'https://www.1xgj.com/ipms/login'
        // loginUrl: 'http://119.27.160.213:8087/web/login'
    },
    mutations: {
    },
    getters: {},
    actions: {}
    // modules:{
    //   page
    // }
});



// WEBPACK FOOTER //
// ./src/store/index.js